{
  "breadcrumbAriaLabel": "麵包屑導覽",
  "homeAriaLabel": "首頁",
  "mainNavAriaLabel": "主導覽",
  "closeSidebarAriaLabel": "關閉側邊欄",
  "collapse": "收合",
  "help": "說明",
  "settings": "設定",
  "myProfile": "我的個人檔案",
  "groups": {
    "clinical": "臨床",
    "worklists": "工作清單",
    "documentation": "病歷文件",
    "orders": "醫囑",
    "medications": "藥物",
    "scheduling": "預約排程",
    "billing": "帳務",
    "analytics": "分析",
    "organization": "組織機構",
    "security": "安全",
    "accessReviews": "Access Reviews",
    "integrations": "整合",
    "system": "系統",
    "licensing": "授權"
  },
  "dashboard": "儀表板",
  "patients": "病患管理",
  "patientSearch": "病患搜尋",
  "myPatients": "我的病患",
  "censusBedBoard": "在院名單 / 床位看板",
  "providerDirectory": "醫師目錄",
  "providerCoverage": "醫師值班覆蓋",
  "patientMerge": "病患資料合併",
  "inbox": "收件匣",
  "pendingResults": "待簽結果",
  "criticalResults": "危急結果",
  "unsignedNotes": "未簽署病歷",
  "cosignQueue": "共同簽署佇列",
  "noteTemplates": "病歷範本",
  "smartPhrases": "智慧片語",
  "orderCatalog": "醫囑目錄",
  "orderSets": "醫囑組合",
  "encounters": "就醫紀錄",
  "orders": "醫囑",
  "results": "檢驗檢查結果",
  "medications": "藥物",
  "notes": "病歷文件",
  "medicationWorklist": "Medication Worklist",
  "formulary": "藥品處方集",
  "pharmacistQueue": "藥師審核佇列",
  "appointments": "預約",
  "scheduleManagement": "排程管理",
  "waitlist": "候診名單",
  "charges": "收費",
  "claims": "理賠申請",
  "payments": "付款",
  "accounts": "帳戶",
  "statements": "對帳單",
  "denials": "拒付",
  "analyticsDashboard": "儀表板",
  "reports": "報表",
  "qualityMeasures": "品質指標",
  "healthSystems": "醫療集團",
  "facilities": "醫療機構",
  "locations": "院區位置",
  "clinicalTaxonomy": "臨床分類",
  "serviceLocation": "服務 ↔ 地點",
  "providers": "醫事人員",
  "users": "使用者",
  "roles": "角色",
  "accessMatrix": "權限矩陣",
  "integrations": "整合",
  "thirdPartyApps": "第三方應用程式",
  "audit": "稽核",
  "system": "系統",
  "cdsRules": "CDS 規則",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "搜尋",
    "register": "登記",
    "demographics": "基本資料",
    "census": "在院名單",
    "discharge": "出院",
    "catalog": "目錄",
    "sets": "醫囑組合",
    "pending": "待處理",
    "critical": "危急",
    "reconciliation": "用藥對照",
    "worklist": "工作清單",
    "templates": "範本",
    "smartPhrases": "智慧片語",
    "schedule": "排程管理",
    "quality": "品質指標",
    "administration": "管理",
    "auditLog": "稽核紀錄",
    "allergies": "過敏史",
    "problems": "問題清單",
    "immunizations": "疫苗接種",
    "insurance": "保險"
  },
  "handoffs": "交接",
  "duplicateReview": "重複病歷審核",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "醫囑工作清單"
}
